import React from "react";

class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { error: null, componentStack: "" };
	}

	static getDerivedStateFromError(error) {
		return { error };
	}

	componentDidCatch(error, info) {
		console.error(error, info);
		this.setState({ componentStack: info.componentStack || "" });
		this.reportToBackend(error, info.componentStack);
	}

	reportToBackend(error, componentStack) {
		try {
			const backendUrl = process.env.REACT_APP_BACKEND_URL;
			if (!backendUrl) return;

			fetch(`${backendUrl}/frontend-errors`, {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({
					message: error?.message || String(error),
					componentStack,
					route: window.location.href,
					userId: localStorage.getItem("userId"),
					companyId: localStorage.getItem("companyId"),
					userAgent: navigator.userAgent,
				}),
			}).catch(() => {});
		} catch {}
	}

	render() {
		if (this.state.error) {
			return (
				<div
					style={{
						padding: 24,
						fontFamily: "monospace",
						whiteSpace: "pre-wrap",
						wordBreak: "break-word",
						color: "#c0392b",
						background: "#fff",
						height: "100vh",
						overflow: "auto",
					}}
				>
					<h2 style={{ marginTop: 0 }}>Se produjo un error</h2>
					<div>{this.state.error.message}</div>
					<h3 style={{ marginBottom: 4, fontSize: 14 }}>Componente</h3>
					<pre style={{ fontSize: 12, opacity: 0.85 }}>{this.state.componentStack}</pre>
					<h3 style={{ marginBottom: 4, fontSize: 14 }}>Stack técnico</h3>
					<pre style={{ fontSize: 12, opacity: 0.7 }}>{this.state.error.stack}</pre>
				</div>
			);
		}
		return this.props.children;
	}
}

export default ErrorBoundary;
